// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { ReflectableIcon as BaseIcon, type IconProps } from '../BaseIcon'
import { rtlFlipCss } from '../iconStyles'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path
      fillRule="evenodd"
      d="M5 17h7.59l-2.2-2.2a1 1 0 0 1-.28-.89A6 6 0 0 1 16 9h.66a7 7 0 0 0-9.02 1.52 1 1 0 0 1-1.4.12l-.07-.06L5 9.41v7.6Zm10 2H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1.72-.7l2.14 2.14A9 9 0 0 1 22 15a1 1 0 0 1-2 0 4 4 0 0 0-7.8-1.22l3.51 3.51A1 1 0 0 1 15 19Z"
      className={rtlFlipCss}
    />
  </BaseIcon>
)
